module.exports = __webpack_public_path__ + "static/icon_3-29c10d0c9807cadbfee20c54f03b8740.png";